import { CurrencyInput } from 'cpool-components/input/CurrencyInput';
import type { Control, FieldValues, Path } from 'react-hook-form';

import { FormField } from './FormField';

type FormCurrencyInputProps<TFieldValues extends FieldValues> = {
    control: Control<TFieldValues>;
    disabled?: boolean;
    id: Path<TFieldValues>;
    label: string;
    labelClassName?: string;
    min?: number;
    max?: number;
};

export const FormCurrencyInput = <TFieldValues extends FieldValues>({
    control,
    disabled,
    id,
    label,
    labelClassName = 'h-8 w-[175px] shrink-0 justify-start',
    max,
    min,
}: FormCurrencyInputProps<TFieldValues>) => (
    <FormField<TFieldValues, number | null> control={control} name={id}>
        {({ error, onChange, value }) => (
            <CurrencyInput
                id={id}
                label={label}
                value={value}
                onChange={onChange}
                min={min}
                max={max}
                disabled={disabled}
                labelClassName={labelClassName}
                className="w-full min-w-0 [&>div]:min-w-0"
                error={error}
            />
        )}
    </FormField>
);
